import { applyMiddleware, compose, createStore } from 'redux'
import { thunk } from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootReducer from 'core/reducers'
import rootSaga from 'core/sagas'
import featureToggles from 'shared/featureToggles'

export default () => {
    const persistConfig = {
        key: 'root',
        storage,
        whitelist: ['waitingList'],
    }

    const persistedReducer = persistReducer(persistConfig, rootReducer)
    const sagaMiddleware = createSagaMiddleware()
    const middleware = [thunk, sagaMiddleware]

    const enhancers = []
    let composeEnhancers = compose

    if (featureToggles.hasReduxDevTools) {
        const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        if (typeof composeWithDevToolsExtension === 'function') composeEnhancers = composeWithDevToolsExtension
    }

    const store = createStore(
        persistedReducer,
        undefined,
        composeEnhancers(applyMiddleware(...middleware), ...enhancers)
    )

    sagaMiddleware.run(rootSaga)

    if (module.hot) {
        module.hot.accept('./reducers', () => {
            store.replaceReducer(rootReducer)
        })
    }
    const persistor = persistStore(store)

    return { store, persistor }
}
